import { useRef, useEffect } from 'react';

export default function usePrevious(value, opt = { withInitValue: true }) {
  const ref = useRef(opt.withInitValue ? value : undefined);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
